import { ChatChannelInstance, useMyMembership as useMyMembershipPackage } from '@packages/chat'
import { useChannelMembershipState } from 'stream-chat-react'

export function useMyMembership(channel: ChatChannelInstance) {
  const myMember = useChannelMembershipState(channel)
  return useMyMembershipPackage({ channel, myMember })
}
